import { FC } from 'react';
import { QuestionAnswersPage } from './question-answers.page';

export const QuestionAnswersAdminLevelPage: FC = () => <QuestionAnswersPage isAdminRoute={true} />;
